import { some } from 'lodash';
import { createContext, useContext } from 'react';
import { useMap } from 'react-use';

export const NavigationPromptCtx = createContext({});

export const NavigationPromptProvider = ({ children }) => {
  const [dirtyFields, { set, reset }] = useMap({});

  const dirty = some(dirtyFields, (v) => v);

  return (
    <NavigationPromptCtx.Provider value={{ dirty, setDirty: set, reset }}>
      {children}
    </NavigationPromptCtx.Provider>
  );
};

export const useNavigationPromptStore = () => useContext(NavigationPromptCtx);
